function idNorm(id) {
  const n = Number(id);
  return Number.isFinite(n) ? n : String(id);
}

/** Firma de mix madurez para agrupar líneas del carrito (mismo producto + mismo mix → suma cantidad). */
function firmaBreakdown(p) {
  if (!p || !p.breakdown || typeof p.breakdown !== 'object') return '';
  const b = p.breakdown;
  const v = Number(b.verde);
  const f = Number(b.firme);
  const m = Number(b.madura);
  const l = p.breakdownLabels === 'tomate' ? 'tomate' : 'palta';
  if (![v, f, m].every((x) => Number.isFinite(x))) return '';
  return `${l}:${v},${f},${m}`;
}

function mismaLineaCarrito(a, b) {
  if (idNorm(a.id) !== idNorm(b.id)) return false;
  return firmaBreakdown(a) === firmaBreakdown(b);
}

function nuevaLineaId() {
  return `L${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}

const state = () => ({
  carrito: [],
  visible: false,
});

const getters = {
  cantidadProductos: (state) => {
    return state.carrito.reduce((s, p) => s + (Number(p.cantidad) || 0), 0);
  },
  getTotal: (state) => {
    return state.carrito.reduce((total, producto) => {
      const unit = Number(producto.precio);
      const q = Number(producto.cantidad) || 0;
      if (!Number.isFinite(unit)) return total;
      return total + unit * q;
    }, 0);
  },
  getProductos: (state) => {
    return state.carrito;
  },
  getVisibilidad: (state) => {
    return state.visible;
  },
};

const actions = {
  agregarProducto: ({ state, commit }, producto) => {
    if (!producto || producto.id == null) return;
    const cantidadIn = Number(producto.cantidad);
    const canti = Number.isFinite(cantidadIn) && cantidadIn > 0 ? Math.floor(cantidadIn) : 1;
    const rest = { ...producto };
    delete rest.cantidad;
    const payload = { ...rest, cantidad: canti };

    const idx = state.carrito.findIndex((item) => mismaLineaCarrito(item, payload));
    if (idx >= 0) {
      const row = state.carrito[idx];
      row.cantidad = (Number(row.cantidad) || 0) + canti;
      if (payload.breakdown && !row.breakdown) {
        row.breakdown = payload.breakdown;
        row.breakdownLabels = payload.breakdownLabels;
      }
    } else {
      const carritoLineId = payload.carritoLineId || nuevaLineaId();
      state.carrito.push({ ...payload, carritoLineId });
    }
    commit('SET_CARRITO', [...state.carrito]);
  },
  cambiarVisibilidadCarrito(context, visibilidad) {
    context.commit('CAMBIAR_VISIBILIDAD_CARRITO', visibilidad);
  },
  removerProducto({ state, commit }, producto) {
    const idx = producto.carritoLineId
      ? state.carrito.findIndex((item) => item.carritoLineId === producto.carritoLineId)
      : state.carrito.findIndex((item) => idNorm(item.id) === idNorm(producto.id) && !item.carritoLineId);
    const useIdx = idx >= 0 ? idx : state.carrito.findIndex((item) => idNorm(item.id) === idNorm(producto.id));
    if (useIdx < 0) return;
    const row = state.carrito[useIdx];
    if (row.cantidad > 1) {
      row.cantidad--;
    } else {
      state.carrito.splice(useIdx, 1);
    }
    commit('SET_CARRITO', [...state.carrito]);
  },
  eliminarProducto({ state, commit }, producto) {
    if (producto.carritoLineId) {
      state.carrito = state.carrito.filter((item) => item.carritoLineId !== producto.carritoLineId);
    } else {
      state.carrito = state.carrito.filter((item) => idNorm(item.id) !== idNorm(producto.id));
    }
    commit('SET_CARRITO', [...state.carrito]);
  },
};

const mutations = {
  SET_CARRITO: (state, carrito) => {
    state.carrito = carrito;
  },
  CAMBIAR_VISIBILIDAD_CARRITO(state, visible) {
    state.visible = visible;
    localStorage.setItem('visible', JSON.stringify(visible));
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
